import { Search } from 'semantic-ui-react';

export default Search;
